import { useCallback, useState } from "react";
import { toast } from "sonner";

const apiUrl = process.env.REACT_APP_BACKEND_URL;

export default function usePostRoundReview({ isPro, notes, teams }) {
  const [flowItems, setFlowItems] = useState(null);
  const [finalFocusItems, setFinalFocusItems] = useState(null);
  const [loading, setLoading] = useState("");

  const clearReviews = useCallback(() => {
    setFlowItems(null);
    setFinalFocusItems(null);
  }, []);

  const openReview = useCallback(
    async (path, type) => {
      if (!isPro) {
        toast.info("This post-round review is available with Pro.");
        return;
      }
      if (!Object.keys(notes).length) {
        toast.error("Add round notes before opening a review.");
        return;
      }
      setLoading(type);
      try {
        const response = await fetch(`${apiUrl}/api/analysis/${path}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            pro_team: teams.pro,
            con_team: teams.con,
            notes,
          }),
        });
        if (response.status === 402) {
          toast.info("This post-round review is available with Pro.");
          return;
        }
        if (response.status === 409) {
          toast.info("End the round before opening a review.");
          return;
        }
        if (!response.ok) throw new Error("Post-round review is unavailable.");
        const review = await response.json();
        if (type === "flow") {
          setFlowItems(review.items);
        } else {
          setFinalFocusItems(review.items);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading("");
      }
    },
    [isPro, notes, teams],
  );

  return {
    clearReviews,
    finalFocusItems,
    flowItems,
    loading,
    openReview,
  };
}